import { styled, minimumWidth, LinkButton } from '@feast-it/ui/light';
import { motion } from 'motion/react';
import { StickyCTAVariant } from './StickyCTA';

interface StickyCTAProps {
  variant: StickyCTAVariant;
}

export const IntersectionObserver = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 50vh;
  z-index: -1;
`;

export const Container = styled(motion.div)<StickyCTAProps>(
  ({ theme, variant }) => `
    position: fixed;
    z-index: 5;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;

    ${
      variant === 'full'
        ? `
      border-top: 1px solid ${theme.colors.mediumGrey};
      background-color: ${theme.colors.white};
    `
        : ''
    }

    ${minimumWidth(theme.breakpoints.small)} {
      padding-bottom: ${theme.spacing[3]};
    }
  `
);

export const Content = styled.div<StickyCTAProps>(
  ({ theme, variant }) => `
    padding: ${theme.spacing[4]};
    width: 100%;
    display: flex;
    align-items: center;
    gap: ${theme.spacing[4]};

    ${
      variant === 'elevated'
        ? `
      border-top: 1px solid ${theme.colors.mediumGrey};
      background-color: ${theme.colors.white};
      padding: ${theme.spacing[4]} ${theme.spacing[3]};

      ${minimumWidth(theme.breakpoints.small)} {
        border: 1px solid ${theme.colors.mediumGrey};
        box-shadow: ${theme.shadows[0]};
        border-radius: ${theme.radii[1]};
      }
    `
        : ''
    }

    ${minimumWidth(theme.breakpoints.small)} {
      width: auto;
    }
  `
);

export const StyledText = styled.div(
  ({ theme }) => `
    display: none;

    ${minimumWidth(theme.breakpoints.small)} {
      padding-left: ${theme.spacing[2]};
      display: block;
    }
  `
);

export const StyledButton = styled(LinkButton)(
  ({ theme }) => `
    width: 100%;
    display: flex;
    justify-content: center;

    ${minimumWidth(theme.breakpoints.small)} {
      width: auto;
    }
  `
);
